<script lang="ts">
    import MagnifyableProductImage from "./MagnifyableProductImage.svelte"

    export let previewImages: Image[] = []
</script>

<section id="productPreviewSlider">
    <div class="wrapper">
        {#each previewImages as previewImage}
            <MagnifyableProductImage
                src="{previewImage?.url}"
                alt="{previewImage?.altText}"
            />
        {/each}
    </div>
</section>

<style lang="less">
    #productPreviewSlider {
        width: 100%;
        max-width: 100%;
        height: min(65vh, 38.25rem);
        position: relative;

        .wrapper {
            display: flex;
            gap: 0px;
            overflow-x: auto;
            width: 100%;
            max-width: 100%;
            height: 100%;
            overflow-y: hidden;
            position: relative;
            &::-webkit-scrollbar {
                width: 6px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: var(--primary-100);
                cursor: pointer;
            }

            &::-webkit-scrollbar-track {
                background: black;
                background-clip: padding-box;
            }
        }
    }
</style>
